<template>
  <dc-layout-main :is-breadcrumb="true">
    <dc-layout-content>
      <a-tabs v-model:activeKey="activeKey">
        <a-tab-pane key="1" tab="国家信息">
          <list></list>
        </a-tab-pane>
        <a-tab-pane key="2" tab="省/州信息">
          <provinceList></provinceList>
        </a-tab-pane>
        <a-tab-pane key="3" tab="城市信息">
          <cityList></cityList>
        </a-tab-pane>
        <a-tab-pane key="4" tab="县区信息">
          <countiesList></countiesList>
        </a-tab-pane>
      </a-tabs>
    </dc-layout-content>
  </dc-layout-main>
</template>

<script lang="ts">
import { ref, defineComponent } from 'vue'
import list from './components/list.vue'
import cityList from './components/cityList.vue'
import provinceList from './components/provinceList.vue'
import countiesList from './components/countiesList.vue'

export default defineComponent({
  name: 'DcCosFbuAdministrativeRegion',
  components: {
    list,
    cityList,
    provinceList,
    countiesList
  },
  setup() {
    const activeKey = ref('1')

    return {
      activeKey
    }
  }
})
</script>

<style scoped></style>
